import {Component, OnInit} from "@angular/core";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {HttpClient} from "@angular/common/http";
import {AuthService} from "angular2-social-login";
import {ValidationService} from "../../services/validation.service";
import {Conf} from "../../settings/config";
import {NgbActiveModal, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {LoginComponent} from "../login/login.component";

@Component({
  selector: 'app-forgot',
  templateUrl: './forgot.component.html'
})
export class ForgotComponent implements OnInit {
  forgotForm: FormGroup;
  error = {
    username: '',
    email: '',
    password: '',
    login: '',
  };
  emailExist: boolean;

  constructor(private modalService: NgbModal,
              public activeModal: NgbActiveModal,
              private fb: FormBuilder,
              private http: HttpClient,
              public _auth: AuthService) {
      this.emailExist = false;
    this.forgotForm = fb.group({
      'email': [null, [Validators.required, ValidationService.emailValidator]],
    });
  }

  ngOnInit() {
  }


  clickResetPassword() {
    this.error = {
      username: '',
      email: '',
      password: '',
      login: '',
    };
    this.http.post(Conf.API_URL + '/auth-users/forgot-password/', {
      email: this.forgotForm.value.email,
    }).subscribe(
        data => {
          $('#forgot_form').hide();
          $('#forgot_form_success').show();
        },
        error => {
          var this_e = this;
          $.each(error.error, function (index, value) {
            if (value[0] === 'This email address does not exist.') {
              this_e.emailExist = true;
            }
            if (value[0] == 'This field may not be null.') {
              value[0] = 'This field is required'
            }
            this_e.error[index] = value[0];
          })
        }
    );
  }

  openLogin() {
    this.closePopup();
    this.modalService.open(LoginComponent, {size: "sm"});
  }


  closePopup() {
    this.error = {
      username: '',
      email: '',
      password: '',
      login: '',
    };
    this.activeModal.close();
  }

}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/dialogs/forgot/forgot.component.ts